import Dashelement from "components/Dashboard/Dashelement";
import TermsCondition from "./TermsCondition";
import PrivacyPolShopify from "./PrivacyPolShopify";
import StoreTermsCondition from "./StoreTermsCondition";
import GuestTermsCondition from "./GuestTermscondition";
import { useSearchParams } from "react-router-dom";
import "./LegalAgreements.css"

export const TermsAndConditionsPB = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = searchParams.get("page") || "guest";

  const handleTabChange = (selectedPage) => {
    setSearchParams({ page: selectedPage });
  };

  const renderContent = () => {
    switch (page) {
      case "store":
        return <StoreTermsCondition />;
      case "guest":
        return <GuestTermsCondition />;
      default:
        return <TermsCondition />;
    }
  };

  return (
    <Dashelement className="features">
      
      <div className="tabs">
        <button
          className={page === "guest" ? "active" : ""}
          onClick={() => handleTabChange("guest")}
        >
          Guest Terms
        </button>
        <button
          className={page === "host" ? "active" : ""}
          onClick={() => handleTabChange("host")}
        >
          Real Customer Terms
        </button>

        <button
          className={page === "store" ? "active" : ""}
          onClick={() => handleTabChange("store")}
        >
          Store Terms
        </button>
      </div>

      {renderContent()}
    </Dashelement>
  );
};


export const PrivacyPolicyPB = () => {
  return (
    <Dashelement className="features">
      {/* <PrivacyPol /> */}
      <PrivacyPolShopify />
    </Dashelement>
  );
};
